<button class="btn {{ type }}" type="{{typeAtributte}}" id="{{ id }}" [disabled]=disabled>
  {{ label }}
  <img *ngIf="icon" [src]="srcIcon" class="icon" alt="icon">
</button>
